module.exports = __webpack_public_path__ + "static/media/ElectricityIcon.31f4aa88.svg";